import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ContractorAuthenticationModal from '../../../../components/family-plaza/ContractorAuthenticationModal';
import PortraitPhotoRegistrationModal from '../../../../components/family-plaza/PortraitPhotoRegistrationModal';
import { checkModalAuthenticationStatus } from '../../../../utils/authUtils';
import { getUserInfo } from '../../../../utils/auth';
import { createMemorialPost, updateMemorialPost, createCherishLetter } from '../../../../api';
import DeceasedPersonProfile from '../../../../components/family-plaza/DeceasedPersonProfile';
import FamilyPlazaTopSection from '../../../../components/family-plaza/FamilyPlazaTopSection';
import FamilyPlazaSubHeading from '../../../../components/family-plaza/FamilyPlazaSubHeading';

const MemorialPostWritingMobile = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('');
  const [password, setPassword] = useState('');
  const [isPrivate, setIsPrivate] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingPostId, setEditingPostId] = useState(null);

  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('/mobile donate/group-129.png');
  const navigate = useNavigate();

  // Load existing post data for edit mode
  useEffect(() => {
    const selectedPostData = localStorage.getItem('selectedMemorialPost');
    if (selectedPostData) {
      try {
        const postData = JSON.parse(selectedPostData);
        setTitle(postData.title || '');
        setContent(postData.content || '');
        setPassword(postData.password || '');
        setIsPrivate(postData.isPrivate || false);
        setIsEditMode(true);
        setEditingPostId(postData.id);
      } catch (error) {
        console.error('Error parsing selected post data:', error);
      }
    }
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleCancel = () => {
    // Clear the selected post data if in edit mode
    if (isEditMode) {
      localStorage.removeItem('selectedMemorialPost');
    }
    navigate('/memorial-post-board-list');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Get customer name from localStorage
    const selectedPersonData = localStorage.getItem('selectedPersonData');
    let customerName = 'default';
    
    if (selectedPersonData) {
      try {
        const personData = JSON.parse(selectedPersonData);
        customerName = personData.customerName || 'default';
      } catch (error) {
        customerName = 'default';
      }
    }
    
    try {
      const selectedPersonData = localStorage.getItem('selectedPersonData');
      let goinId = null;
      
      if (selectedPersonData) {
        try {
          const personData = JSON.parse(selectedPersonData);
          goinId = personData.goinId || null;
        } catch (error) {
          goinId = null;
        }
      }
      
      // Get registId from userInfo
      const userInfo = getUserInfo();
      const registId = userInfo?.userId || userInfo?.id || 0;
      
      // Use the new cherish write API
      const cherishData = {
        cherishId: 0,
        goinId: goinId || 0,
        registId: registId,
        letterTitle: title.trim(),
        letterContents: content.trim(),
        password: password
      };
      
      const response = await createCherishLetter(cherishData);
      
      if (response && response.status === 200) {
        console.log('Memorial post created successfully via cherish API');
      } else {
        console.log('Cherish API failed, falling back to old API');
        
        // Fallback to old API
        const postData = {
          boardId: 1,
          title: title.trim(),
          content: content.trim(),
          password: password,
          isPrivate: isPrivate,
          author: 'Anonymous'
        };
        
        if (isEditMode) {
          await updateMemorialPost({
            ...postData,
            id: editingPostId
          });
        } else {
          await createMemorialPost(postData);
        }
      }
      
      // Also save to localStorage as backup
      const postsKey = `memorialPosts_${customerName}`;
      const existingPosts = localStorage.getItem(postsKey);
      let posts = [];
      
      if (existingPosts) {
        try {
          posts = JSON.parse(existingPosts);
        } catch (error) {
          posts = [];
        }
      }
      
      // Create new post object for localStorage
      const newPost = {
        id: isEditMode ? editingPostId : Date.now().toString(),
        title: title.trim(),
        content: content.trim(),
        password: password,
        isPrivate: isPrivate,
        customerName: customerName,
        date: new Date().toISOString(),
        author: 'Anonymous'
      };
      
      if (isEditMode) {
        // Update existing post in localStorage
        const postIndex = posts.findIndex(post => post.id === editingPostId);
        if (postIndex !== -1) {
          posts[postIndex] = { ...posts[postIndex], ...newPost };
        }
      } else {
        // Add new post to localStorage
        posts.unshift(newPost);
      }
      
      // Sort by date - most recent first
      const sortedPosts = posts.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB - dateA; // Descending order (newest first)
      });
      
      // Save back to localStorage
      localStorage.setItem(postsKey, JSON.stringify(sortedPosts));
      
      // Clear the selected post data if in edit mode
      if (isEditMode) {
        localStorage.removeItem('selectedMemorialPost');
      }
      
      // Dispatch event to notify other components
      window.dispatchEvent(new CustomEvent('memorialPostUpdated', {
        detail: {
          customerName: customerName,
          postData: isEditMode ? { id: editingPostId, title, content, password, isPrivate } : null
        }
      }));
      
      // Navigate to the memorial post board list
      navigate('/memorial-post-board-list');
      
    } catch (error) {
      console.error('API failed, falling back to localStorage only:', error);
      
      // Fallback to localStorage only if API fails
    const postsKey = `memorialPosts_${customerName}`;
    const existingPosts = localStorage.getItem(postsKey);
    let posts = [];
    
    if (existingPosts) {
      try {
        posts = JSON.parse(existingPosts);
      } catch (error) {
        posts = [];
      }
    }
    
      // Create new post object
    const newPost = {
      id: isEditMode ? editingPostId : Date.now().toString(),
      title: title.trim(),
      content: content.trim(),
      password: password,
      isPrivate: isPrivate,
      customerName: customerName,
      date: new Date().toISOString(),
      author: 'Anonymous'
    };
    
    if (isEditMode) {
      // Update existing post
      const postIndex = posts.findIndex(post => post.id === editingPostId);
      if (postIndex !== -1) {
        posts[postIndex] = { ...posts[postIndex], ...newPost };
      }
    } else {
      // Add new post
      posts.unshift(newPost);
    }
      
      // Sort by date - most recent first
      const sortedPosts = posts.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB - dateA; // Descending order (newest first)
      });
    
    // Save back to localStorage
      localStorage.setItem(postsKey, JSON.stringify(sortedPosts));
    
    // Clear the selected post data if in edit mode
    if (isEditMode) {
      localStorage.removeItem('selectedMemorialPost');
    }
    
    // Dispatch event to notify other components
    window.dispatchEvent(new CustomEvent('memorialPostUpdated', {
      detail: {
        customerName: customerName,
        postData: isEditMode ? { id: editingPostId, title, content, password, isPrivate } : null
      }
    }));
    
    // Navigate to the memorial post board list
    navigate('/memorial-post-board-list');
    }
  };

  const handleNavigation = (route) => {
    navigate(route);
  };

  const handleMemorialPost = () => {
    navigate('/cyber-memorial-search');
  };

  const handleLetterToHeaven = () => {
    navigate('/letter-to-heaven-board-list');
  };

  const handleManagementInquiry = () => {
    navigate('/management-search');
  };

  const handleAncestralTablet = () => {
    navigate('/ancestral-tablet');
  };

  const handleViewPost = () => {
    navigate('/memorial-post-details');
  };

  // Photo icon click handler
  const handlePhotoIconClick = () => {
    if (checkModalAuthenticationStatus()) {
      setShowPhotoModal(true);
    } else {
      setShowAuthModal(true);
    }
  };

  // Authentication modal handlers for camera icon
  const handleAuthConfirm = () => {
    setShowAuthModal(false);
    // Proceed with form submission after authentication
    handleSubmit({ preventDefault: () => {} });
  };

  const handleAuthClose = () => {
    setShowAuthModal(false);
  };



  // Photo registration modal handlers
  const handlePhotoConfirm = () => {
    setShowPhotoModal(false);
  };

  const handlePhotoUpload = (photoUrl) => {
    setProfilePhotoUrl(photoUrl);
  };

  const handlePhotoClose = () => {
    setShowPhotoModal(false);
  };

  return (
    <div className="memorial-post-writing-mobile-unique announcement-list-page cyber-info-page-pc">
      
      <FamilyPlazaTopSection />
  
     <main className="main-content">
  
      <FamilyPlazaSubHeading heading="사이버추모관" />
      
      <DeceasedPersonProfile 
        handlePhotoIconClick={handlePhotoIconClick}
      />

      

      {/* Navigation Tabs */}
      <div className="memorial-post-writing-mobile-nav-tabs-unique">
        <button 
          className="memorial-post-writing-mobile-nav-tab-unique"
          onClick={() => navigate('/donate')}
        >
          <span>헌화하기</span>
        </button>
        <button 
          className="memorial-post-writing-mobile-nav-tab-unique memorial-post-writing-mobile-nav-tab-active-unique"
          onClick={() => navigate('/memorial-post-board-list')}
        >
          <span>추모글</span>
        </button>
        <button 
          className="memorial-post-writing-mobile-nav-tab-unique"
          onClick={() => navigate('/memorial-album-board-list')}
        >
          <span>추모앨범</span>
        </button>
      </div>

      {/* Writing Form Section */}
      <div className="memorial-post-writing-mobile-form-section-unique">
        <form onSubmit={handleSubmit}>
          <div className="memorial-post-writing-mobile-form-container-unique">
            
            {/* Title Section */}
            <div className="memorial-post-writing-mobile-form-field-unique">
              <label className="memorial-post-writing-mobile-form-label-unique">제목</label>
              <input 
                type="text" 
                className="memorial-post-writing-mobile-form-input-unique"
                placeholder=""
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>

            {/* Private Post Checkbox */}
            <div className="memorial-post-writing-mobile-checkbox-section-unique">
              <div className="memorial-post-writing-mobile-checkbox-container-unique">
                <input 
                  type="checkbox" 
                  id="private-post" 
                  checked={isPrivate}
                  onChange={(e) => setIsPrivate(e.target.checked)}
                  className="memorial-post-writing-mobile-checkbox-unique"
                />
                <label htmlFor="private-post" className="memorial-post-writing-mobile-checkbox-label-unique">
                  체크 시 비밀글로 등록됩니다.
                </label>
              </div>
            </div>

            {/* Section Separator */}
            <div className="memorial-post-writing-mobile-separator-unique"></div>

            {/* Password Section */}
            <div className="memorial-post-writing-mobile-form-field-unique">
              <div className="memorial-post-writing-mobile-password-header-unique">
                <label className="memorial-post-writing-mobile-form-label-unique">비밀번호</label>
                <span className="memorial-post-writing-mobile-password-hint-unique">영문+숫자 10자리 미만</span>
              </div>
              <input 
                type="password" 
                className="memorial-post-writing-mobile-form-input-unique"
                placeholder=""
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {/* Section Separator */}
            <div className="memorial-post-writing-mobile-separator-unique"></div>
            
            {/* Content Section */}
            <div className="memorial-post-writing-mobile-form-field-unique">
              <label className="memorial-post-writing-mobile-form-label-unique">내용</label>
              <textarea 
                className="memorial-post-writing-mobile-form-textarea-unique"
                placeholder=""
                value={content}
                onChange={(e) => setContent(e.target.value)}
                required
                rows="8"
              />
            </div>
          </div>
          
          {/* Action Buttons */}
          <div className="memorial-post-writing-mobile-action-buttons-unique">
            <button type="submit" className="memorial-post-writing-mobile-submit-button-unique">
              {isEditMode ? '수정' : '등록'}
            </button>
            <button type="button" className="memorial-post-writing-mobile-cancel-button-unique" onClick={handleCancel}>
              취소
            </button>
          </div>
        </form>
      </div>

      {/* Authentication Modal */}
      <ContractorAuthenticationModal
        isOpen={showAuthModal}
        onConfirm={handleAuthConfirm}
        onClose={handleAuthClose}
      />

      {/* Photo Registration Modal */}
      <PortraitPhotoRegistrationModal
        isOpen={showPhotoModal}
        onConfirm={handlePhotoConfirm}
        onClose={handlePhotoClose}
        onPhotoUpload={handlePhotoUpload}
      />
      </main>
    </div>
  );
};

export default MemorialPostWritingMobile; 